import {
  Inline,
  IconSearch,
  IconUpload,
  IconRefresh,
  Link,
} from 'braid-design-system';
import queryString from 'query-string';
import React from 'react';
import { useSelector } from 'react-redux';

import ExternalLink from 'src/components/ExternalLink/ExternalLink';
import { getConfigValues } from 'src/config';
import Routes from 'src/config/routes';
import { ListingStatus } from 'src/generated/graphql';
import type { StoreProps } from 'src/store';
import type { ClientListingForListingsTab } from 'src/types/graphql-derived';

import Action from './Action';
import { EditAction } from './EditAction';

interface UnpostedViewProps {
  listing: ClientListingForListingsTab;
  onEditClick: () => void;
  onPreviewClick: () => void;
  onPaidPostClick: () => void;
  onUnpaidPostClick: () => void;
}

export const UnpostedView = ({
  listing,
  onEditClick,
  onPreviewClick,
  onPaidPostClick,
  onUnpaidPostClick,
}: UnpostedViewProps) => {
  const hasPaid = useSelector((store: StoreProps) => store.account.paid);
  const postLabel = listing.status === ListingStatus.Draft ? 'Post' : 'Repost';
  const postIcon =
    listing.status === ListingStatus.Draft ? IconUpload : IconRefresh;

  return (
    <Inline space="large">
      <ExternalLink
        destination={`${queryString.stringifyUrl({
          url: getConfigValues().ADVERTISER_CENTRE_URL + Routes.CREATE_AD_URL,
          query: {
            ClientId: listing.clientId,
            listingId: listing.id,
            Preview: true.toString(),
            FromList: true.toString(),
          },
        })}`}
      >
        <Action Icon={IconSearch} action="Preview" onClick={onPreviewClick} />
      </ExternalLink>

      {hasPaid ? (
        <Action Icon={postIcon} action={postLabel} onClick={onPaidPostClick} />
      ) : (
        <Link
          href={queryString.stringifyUrl({
            url: Routes.PACKAGES,
            query: { listingId: listing.id },
          })}
        >
          <Action
            Icon={postIcon}
            action={postLabel}
            onClick={onUnpaidPostClick}
          />
        </Link>
      )}

      <EditAction listing={listing} onClick={onEditClick} />
    </Inline>
  );
};
